import React, { useRef, useEffect, useImperativeHandle, forwardRef } from "react";

const ALTCHA_ENDPOINT = process.env.GATSBY_ALTCHA_ENDPOINT;
const challengeurl = `${ALTCHA_ENDPOINT}/challenge`;

const AltchaWidget = forwardRef(({ onChange }, ref) => {
  const widgetRef = useRef(null);
  const valueRef = useRef(null);

  useImperativeHandle(
    ref,
    () => {
      return {
        get value() {
          return valueRef.current;
        },
        reset() {
          widgetRef.current?.reset();
        },
      };
    },
    []
  );

  useEffect(() => {
    import("altcha");
  }, []);

  useEffect(() => {
    const handleStateChange = (ev) => {
      if ("detail" in ev) {
        valueRef.current = ev.detail.payload || null;
        onChange?.(ev.detail.payload || null);
      }
    };
    const { current } = widgetRef;
    if (current) {
      current.addEventListener("statechange", handleStateChange);
      return () => current.removeEventListener("statechange", handleStateChange);
    }
  }, [onChange]);

  return <altcha-widget ref={widgetRef} challengeurl={challengeurl}></altcha-widget>;
});

export default AltchaWidget;
